export default {
   components: {
      TopNav: () => import('./top-nav'),
      SideNav: () => import('./side-nav'),
      Breadcrumb: () => import('./breadcrumb'),
   },
   routes: [
      {
         path: '/user',
         component: () => import(`./layout`),
         name: 'Layout'
      }
   ]
}